import { useCallback, useMemo, useState } from 'react';

export interface IMetaTagsState {
  title: string,
  description: string,
  withSuffix?: boolean,
}

export interface IUseMetaTags {
  state: IMetaTagsState,
  setMetaTags: (payload: IMetaTagsState) => void,
}

const INITIAL_META_TAGS: IMetaTagsState = {
  title: '',
  description: '',
  withSuffix: true,
};

const useMetaTags = (): IUseMetaTags => {
  const [state, setState] = useState<IMetaTagsState>(INITIAL_META_TAGS);

  const setMetaTags = useCallback(({ title, description, withSuffix }: IMetaTagsState): void => {
    setState({ title, description, withSuffix });
  }, []);

  return useMemo(() => ({ state, setMetaTags }), [state, setMetaTags]);
};

export default useMetaTags;
